// import logo from './logo.svg';
// import './App.css';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'lenis/dist/lenis.css';
import Routers from "./Routers";

function App() {
  return (
    <div className="App">
         <Routers/>
    </div>
  );
}

export default App;
